import React from 'react'
import FaCloudUpload from 'react-icons/lib/fa/cloud-upload'
import FaCogs from 'react-icons/lib/fa/cogs'
import './videoProgress.css'
import { getFirstFile } from '../utilities'

export default ({video, className}) => {
  let file = getFirstFile(video)
  return (
    <div className={(className || "") + " progress-overlay"}>
      {!(video.status > 0) || video.upload_percent > 0
        ? <div className={(video.upload_percent !== 100 ? 'active ': '') + 'upload-progress progress-row'}>
            <FaCloudUpload />
            {video.waitingToUpload
              ? <div className="progress-status">Upload queued</div>
              : <div className="progress-bar-track">
                  <div className="progress-bar-value" style={{width: (video.upload_percent || 0) + "%"}}>
                  </div>
                </div>
            }
            {video.upload_speed != null ? <span className="speed">{((video.upload_speed / 1048576) * 8).toFixed(1)} Mbps</span> : ""}
          </div>
        : ""
      }
      {video.status === 1 || (file && file.reencoded) 
        ? video.queued
          ? <div className="progress-status">Queued for processing</div>
          : <div className={(video.percent || video.upload_percent === 100 ? 'active ': '') + 'transcode-progress progress-row'}>
              <FaCogs />
              <div className="progress-bar-track">
                <div className="progress-bar-value" style={{width: (video.percent || 0) + "%"}}>
                </div>
              </div>
            </div>
        : ""
      }
    </div>
  )
}